import React from 'react';
import { useClickAway } from 'react-use';

import { useStartupCXI } from '../../useStartupCXI';

import { ContainerBody } from './ContainerBody';
import { ContainerHead } from './ContainerHead';
import { ContainerFeet } from './ContainerFeet';
import { ContainerSlim } from './ContainerSlim';

import * as Styled from './StyledContainer';

const Container = ({ children, ...props }) => {
    const { setModal } = useStartupCXI();

    const containerRef = React.useRef(null);

    useClickAway(containerRef, () => {
        if (props.dontClickAway !== true) {
            setModal(null);
        }
    });

    return (
        <Styled.Container {...props} ref={containerRef}>
            <Styled.Close onClick={() => setModal(null)}>
                <span className="icon far fa-times" aria-hidden="true" />
            </Styled.Close>

            {children}
        </Styled.Container>
    );
};

Container.Body = ContainerBody;
Container.Head = ContainerHead;
Container.Feet = ContainerFeet;
Container.Slim = ContainerSlim;

export { Container };
